import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LoginPageComponent } from './login-page/login-page.component';
import { AdminLoginPageComponent } from './admin-login-page/admin-login-page.component';
import { SsoPageComponent } from 'app/theme/sso-page/sso-page.component';

const routes: Routes = [ 
  { path: 'login', component: LoginPageComponent },
  { path: 'loginAdmin', component: AdminLoginPageComponent },
  { path: 'sso', component: SsoPageComponent },
  { path: 'logout', redirectTo: '/', pathMatch: 'full' },
];

@NgModule({
  imports: [
    CommonModule
    ,RouterModule.forChild(routes)
  ],
  exports: [ RouterModule ],
  declarations: []
})
export class ThemeRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/theme/theme-routing.module.ts